<template>
  <transition name="enter-left">
    <div v-if="toggle" class="sidebar">
      <h2>
        <a href="/" class="sidebar__title">My DSCVR</a>
      </h2>
      <div class="sidebar__inner">
        <sidebar-nav title="OFFERS" :icon="tag" :links="offers" />
        <sidebar-nav title="MERCHANTS" :icon="user" :links="merchants" />
        <sidebar-nav title="OUTLETS" :icon="store" :links="outlets" />
      </div>

      <div class="sidebar__footer">
        <v-img src="@/assets/logo_white.png" class="sidebar__footer--logo" />
        <p class="sidebar__footer--version">Version: v{{ version }}</p>
      </div>
    </div>
  </transition>
</template>

<script>
import SidebarNav from "./SidebarNav";
import { mapState, mapActions } from "vuex";

export default {
  name: "Sidebar",

  components: {
    SidebarNav
  },

  props: {
    version: String
  },

  methods: {
    ...mapActions({ switchToggle: "ui/switchToggle" })
  },

  computed: {
    ...mapState({ ui: state => state.ui }),

    toggle() {
      return this.ui.toggle;
    },

    offers() {
      return [
        {
          type: "listed-offers",
          name: "All offers",
          route: "/allOffers"
        },
        {
          type: "new-offer",
          name: "Create offer",
          route: "/addOffer"
        }
      ];
    },

    merchants() {
      return [
        {
          type: "merchantList",
          name: "Merchants",
          route: "/merchantList"
        }
      ];
    },

    outlets() {
      return [
        {
          type: "outletList",
          name: "Outlets",
          route: "/outletList"
        }
      ];
    }
  }
};
</script>

<style lang="sass" scoped>
.sidebar
  padding-top: 30px
  background-image: linear-gradient(to bottom left, darken($dark-purple, 5%), lighten($dark-purple, 20%))

  &__title
    position: fixed
    top: 5px
    padding: 10px 0 10px 23px
    font:
      size: 12px
      weight: normal
      family: Roboto
    text-transform: uppercase
    letter-spacing: 1px
    color: $c-gray

    &:hover
      color: $c-white

  &__inner
    position: fixed
    top: 70px
    height: calc(100vh - 200px)

  &__footer
    position: fixed
    bottom: 0px
    display: flex
    justify-content: center
    flex-flow: column
    padding: 15px 20px 5px 10px

    &--logo
      width: 70px

    &--version
      font-size: 8px
      color: $c-white

.enter-left-enter-active, .enter-left-leave-active
  transition: all .3s cubic-bezier(0.175, 0.885, 0.32, 1.15)

.enter-left-enter, .enter-left-leave-to
  transform: translateX(-200px)
  opacity: 0
</style>
